if ( jQuery(".swiper-marquee").length ) {
    let SwiperMarquee = new Swiper('.swiper-marquee', {
        spaceBetween: 0,
        centeredSlides: true,
        speed: 6000,
        autoplay: {
            delay: 1,
        },
        loop: true,
        slidesPerView:'auto',
        allowTouchMove: false,
        disableOnInteraction: true
    });
}